import React from 'react';

import { Box, HStack, Skeleton, VStack } from '@rbilabs/universal-components';

export const ProductSkeleton = () => {
  return (
    <Box flexDirection="row" justifyContent="flex-start" alignItems="flex-start">
      <HStack marginTop="$3" space="$4">
        <Skeleton rounded={12} w="$24" h="$20" />
        <VStack space="$2" justifyContent="center" pr="$4" flex={1}>
          <Skeleton rounded="full" h="$5" />
          <HStack space="$2">
            <Skeleton rounded="full" h="$5" flex={3} />
            <Skeleton rounded="full" h="$5" flex={1} mr="$12" />
          </HStack>
        </VStack>
      </HStack>
    </Box>
  );
};
